export default __webpack_public_path__ + "static/media/tasks_active.922c7eae.svg";